<form class="f-col blank-form" [formGroup]="corporateCardForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.cccorporatecards']}}</h2>
        <a role="button" class="link" *ngIf="commonObjPipes.GetAllCorporateCardDetails.pipe.length>0 && !Addnew"
            (click)="addNewCorporateCard(amexCoBrandedCardTemplate)"><mat-icon fontSet="material-symbols-outlined"
                class="edit-icon">add</mat-icon>{{content?.['b2b.managecompany.addnew']}}</a>
    </div>

    <div class="section-content cm-custom-card-page" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row two--ColLayout">
                <div class="f-col" [class.view-disabled]="corporateCardForm.get('queryNo')?.value==2">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.cccardname']}}</mat-label>
                        <input matInput formControlName="cardName"
                            (keypress)="_CommonService.allowOnlyCharacters($event)" (paste)="onPasteBlocked($event)"
                            (contextmenu)="disableRightClick($event)" [class.view-disabled] data-dd-privacy="mask">
                        <mat-error
                            *ngIf="corporateCardForm.get('cardName')?.hasError('required')">{{dictionaryContent?.['b2b.managecompany.cardnamereq']}}</mat-error>
                        <mat-error
                            *ngIf="corporateCardForm.get('cardName')?.hasError('minlength')">{{dictionaryContent?.['b2b.managecompany.cardnameminlimit']}}</mat-error>
                        <mat-error
                            *ngIf="corporateCardForm.get('cardName')?.hasError('maxlength')">{{dictionaryContent?.['b2b.managecompany.cardnamemaxlimit']}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col" [class.view-disabled]="corporateCardForm.get('queryNo')?.value==2">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.cccardoption']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect.panelOpen ?
                            'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        <mat-select #branchSelect formControlName="cardOption" data-dd-privacy="mask">
                            <mat-option value="Credit card"
                                *ngFor="let cardoption of commonObjPipes.GetCardOption.pipe">
                                {{cardoption.PayMode_Name}} </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="corporateCardForm.get('cardOption')?.hasError('required')&& corporateCardForm.get('cardOption')?.touched">{{dictionaryContent?.['b2b.managetraveler.cardoptionreq']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row two--ColLayout">
                <div class="f-col" [class.view-disabled]="corporateCardForm.get('queryNo')?.value==2">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.cccardtype']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect1.panelOpen ?
                            'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        <mat-select #branchSelect1 formControlName="cardType" data-dd-privacy="mask">
                            <mat-option value="Credit card" *ngFor="let cardType of commonObjPipes.GetCardType.pipe"
                                [value]="cardType.Card_Code"> {{cardType.Card_Name}} </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="corporateCardForm.get('cardType')?.hasError('required')&& corporateCardForm.get('cardType')?.touched">{{dictionaryContent?.['b2b.managetraveler.cardtypereq']}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col" [class.view-disabled]="corporateCardForm.get('queryNo')?.value==2">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.cccardholdername']}}</mat-label>
                        <input matInput formControlName="cardHolderName"
                            (keypress)="_CommonService.allowOnlyCharacters($event)" (paste)="onPasteBlocked($event)"
                            (contextmenu)="disableRightClick($event)" data-dd-privacy="mask">
                        <mat-error
                            *ngIf="corporateCardForm.get('cardHolderName')?.hasError('required')">{{dictionaryContent?.['b2b.managetraveler.cardholdernamereq']}}</mat-error>
                        <mat-error
                            *ngIf="corporateCardForm.get('cardHolderName')?.hasError('minlength')">{{dictionaryContent?.['b2b.managetraveler.cardholdernameminlimit']}}</mat-error>
                        <mat-error *ngIf="corporateCardForm.get('cardHolderName')?.hasError('maxlength')">
                            {{dictionaryContent?.['b2b.managecompany.cardholdernamemaxlimit']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col" [class.view-disabled]="corporateCardForm.get('queryNo')?.value==2">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.cccardno']}}</mat-label>
                        <input matInput formControlName="cardNumber" (keypress)="allowedNumberOnly($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)"
                            [value]="editMode ? corporateCardForm.get('cardNumber')?.value : (corporateCardForm.get('cardNumber')?.value | cardNumberFormat)"
                            [errorStateMatcher]="matcher" data-dd-privacy="mask">
                        <mat-error
                            *ngIf="corporateCardForm.get('cardNumber')?.hasError('required') && corporateCardForm.get('cardNumber')?.touched">{{dictionaryContent?.['b2b.managecompany.cardnumberreq']}}</mat-error>
                        <mat-error
                            *ngIf="corporateCardForm.get('cardNumber')?.hasError('invalidLength') && (corporateCardForm.get('cardNumber')?.touched || corporateCardForm.get('cardNumber')?.dirty)">
                            {{ checkCardLength() }}
                        </mat-error>
                        <mat-error
                            *ngIf="corporateCardForm.get('cardNumber')?.hasError('invalidCardType') && (corporateCardForm.get('cardNumber')?.touched || corporateCardForm.get('cardNumber')?.dirty)">{{dictionaryContent?.['b2b.managecompany.cardnumbernotmatch']}}</mat-error>
                        <mat-error
                            *ngIf="corporateCardForm.get('cardNumber')?.hasError('invalidCard') && (corporateCardForm.get('cardNumber')?.touched || corporateCardForm.get('cardNumber')?.dirty)">
                            Please Enter a valid card Number.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="f-row two--ColLayout">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.ccselexpirymonth']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect3.panelOpen ?
                            'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        <mat-select #branchSelect3 formControlName="expiryMonth" (selectionChange)="checkPastMonth()"
                            data-dd-privacy="mask">
                            <mat-option *ngFor="let month of months" [value]="month.value">{{month.value}}</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="corporateCardForm.get('expiryMonth')?.hasError('expired')">{{dictionaryContent?.['b2b.managecompany.expirydateinvaild']}}</mat-error>
                        <mat-error *ngIf="corporateCardForm.get('expiryMonth')?.hasError('required')">
                            {{dictionaryContent?.['b2b.managetraveler.expirymonthreq']}} </mat-error>


                    </mat-form-field>
                    <!-- <ng-select autoBlurSelect [items]="months" formControlName="expiryMonth" placeholder="Select Expiry Month"  > </ng-select> -->
                    <mat-error
                        *ngIf="corporateCardForm.get('expiryMonth')?.hasError('expired')">{{dictionaryContent?.['b2b.managecompany.expirydateinvaild']}}</mat-error>
                </div>
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.ccselexpiryyear']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect4.panelOpen ?
                            'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        <mat-select #branchSelect4 formControlName="expiryYear" data-dd-privacy="mask">
                            <mat-option *ngFor="let year of years" [value]="year.value"> {{year.value}} </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="corporateCardForm.get('expiryYear')?.hasError('required')">{{dictionaryContent?.['b2b.managetraveler.expiryyearreq']}}
                        </mat-error>
                    </mat-form-field>
                    <!-- <ng-select autoBlurSelect [items]="years" formControlName="expiryYear" placeholder="Select Expiry Year"></ng-select> -->
                    <mat-error
                        *ngIf="corporateCardForm.get('expiryYear')?.hasError('expired')">{{dictionaryContent?.['b2b.managecompany.expirydateinvaild']}}</mat-error>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.cctypeofcard']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="isVirtualCard">
                            <mat-radio-button
                                [value]="true">{{content?.['b2b.managecompany.ccvirtualcard']}}</mat-radio-button>
                            <mat-radio-button
                                [value]="false">{{content?.['b2b.managecompany.ccphysicalcard']}}</mat-radio-button>
                        </mat-radio-group>
                        <mat-error
                            *ngIf="corporateCardForm.get('isVirtualCard')?.hasError('required') && corporateCardForm.get('isVirtualCard')?.touched">
                            {{dictionaryContent?.['b2b.managecompany.selecttypeofcard']}} </mat-error>
                    </div>
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.managecompany.ccconfiguration']}}</label>
                        <div class="f-row mat-check-group">
                            <mat-checkbox class="checkbox-wrapper"
                                formControlName="islodge">{{content?.['b2b.managecompany.cclodge']}}</mat-checkbox>
                            <mat-checkbox class="checkbox-wrapper"
                                formControlName="isChargeAtMerchant">{{content?.['b2b.managecompany.ccchargeatmerchant']}}</mat-checkbox>
                        </div>
                    </div>
                    <!-- <mat-error *ngIf="corporateCardForm.hasError('atLeastOneRequired')">
                        At least one option must be selected (Lodge or Charge at Merchant).
                    </mat-error> -->
                </div>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.ccruleapplied']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix>{{ branchSelect5.panelOpen ?
                            'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                        <mat-select #branchSelect5 formControlName="ruleAppliedOn"
                            (selectionChange)="onRuleAppliedOnChange($event)" data-dd-privacy="mask">
                            <mat-option *ngFor="let item of commonObjPipes.GetRuleAppliesOn.pipe" [value]="item.ID">
                                {{item.Name === 'Corporate-Branch'?'Corporate-Office location':item.Name}} </mat-option>
                        </mat-select>
                        <mat-error *ngIf="corporateCardForm.get('ruleAppliedOn')?.hasError('required')">
                            {{dictionaryContent?.['b2b.managecompany.ruleappliedonreq']}} </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- <div class="f-row" *ngIf="!!corporateCardForm.value.ruleAppliedOn">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">Select Items from the list:</label>
                        <div class="f-row mat-check-group">
                            <mat-checkbox class="checkbox-wrapper" *ngFor="let rule of associatedRuleAppliedOn"
                                [value]="rule.ID" (change)="onCheckboxChange($event, rule.ID)"
                                [checked]="ruleListArray.includes(rule.ID.toString())">{{rule.Name}}</mat-checkbox>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="f-row" *ngIf="!!corporateCardForm.value.ruleAppliedOn">
                <mat-form-field class="mat-chip-input custom-mat-dropdown-parent">
                    <mat-label>{{content?.['b2b.managecompany.select']}} {{ruleAppliedOnName=='Corporate-Branch'?'Office
                        location': ruleAppliedOnName || ""}}(s)</mat-label>
                    <mat-chip-grid #chipGrid aria-label="name">
                        <mat-chip-row *ngFor="let name of associateRuleName" (removed)="remove(name)">
                            {{name}}
                            <button matChipRemove [attr.aria-label]="'remove ' + name">
                                <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [placeholder]="content?.['b2b.managecompany.select']" #fruitInput
                        [formControl]="ruleAppliedFor" [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)"
                        (keypress)="blockInvalidCharacters1($event)" (paste)="onPasteBlocked($event)"
                        (contextmenu)="disableRightClick($event)" />
                    <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete">
                        <mat-option *ngFor="let AssociatedName of filteredAssocatedWithRule | async"
                            [value]="AssociatedName">
                            <div (keydown.enter)="optionClicked(AssociatedName); $event.stopPropagation()"
                                (keyup.space)="optionClicked(AssociatedName); $event.stopPropagation()"
                                (click)="optionClicked(AssociatedName); $event.stopPropagation()">
                                <mat-checkbox class="checkbox-wrapper"
                                    (change)="onCheckboxChange($event, AssociatedName, 'custom-mat-dropdown-parent','custom-autocomplete')"
                                    (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()"
                                    [checked]="this.selectedAssoicatedRuleIdMap[AssociatedName.ID]"></mat-checkbox>
                                {{AssociatedName.Name}}
                            </div>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.product']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix
                            class="mat-select">stat_minus_1</mat-icon>
                        <mat-select formControlName="product">
                            <mat-option [value]="'AIR'"> {{content?.['b2b.managecompany.flight']}} </mat-option>
                            <!-- <mat-option> 02 </mat-option> -->
                        </mat-select>
                        <mat-error *ngIf="corporateCardForm.get('product')?.hasError('required')">
                            {{dictionaryContent?.['b2b.managecompany.productreq']}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small"
                (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" [class.disabled]="this.corporateCardForm.invalid"
                (click)="onSave()">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="commonObjPipes.GetAllCorporateCardDetails.pipe.length >0 && !Addnew">
        <table mat-table [dataSource]="commonObjPipes.GetAllCorporateCardDetails.pipe" class="mat-elevation-z0">
            <!-- Position Column -->
            <ng-container matColumnDef="Card Name">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.cccardname']}} </th>
                <td mat-cell *matCellDef="let element" data-dd-privacy="mask"> {{element.Card_Name}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Card Type">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.cccardtype']}} </th>
                <td mat-cell *matCellDef="let element" data-dd-privacy="mask"> {{element.Card_Type}} </td>
            </ng-container>

            <ng-container matColumnDef="Name on Card">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ccnameoncard']}} </th>
                <td mat-cell *matCellDef="let element" data-dd-privacy="mask"> {{element.Name_on_Card}} </td>
            </ng-container>

            <ng-container matColumnDef="Card Expiry">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.cccardexpiry']}} </th>
                <td mat-cell *matCellDef="let element" data-dd-privacy="mask"> {{element.CardExpiry}} </td>
            </ng-container>

            <ng-container matColumnDef="Currency">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.cccurrency']}} </th>
                <td mat-cell *matCellDef="let element"> {{ isEmptyObject(element.Currency) ? '-' : element.Currency }}
                </td>
            </ng-container>

            <ng-container matColumnDef="Rule applied on">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ccruleapplied']}} </th>
                <td mat-cell *matCellDef="let element"> {{ getRuleAppliedOnName(element.RuleAppliedOn) }} </td>
            </ng-container>

            <ng-container matColumnDef="Product">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ccproduct']}} </th>
                <td mat-cell *matCellDef="let element"> {{isEmptyObject(element.Product) ? '-':
                    getProductName(element.Product)}} </td>
            </ng-container>


            <!-- Symbol Column -->
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a>
                    <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
                    <button class="button-as-span onclick-cell primary-link" aria-label="edit item"
                        (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">Edit</mat-icon></button>
                    <button class="button-as-span onclick-cell warm-link" aria-label="remove item"
                        (click)="onRemove(element)"><mat-icon
                            fontSet="material-symbols-outlined">Delete</mat-icon></button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <ng-container *ngIf="!isLoading && commonObjPipes.GetAllCorporateCardDetails.pipe.length==0 && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event, amexCoBrandedCardTemplate)"
            [heading]="content?.['b2b.managecompany.ccnocorpcardstitle']"
            [content]="content?.['b2b.managecompany.ccnocorpcardsdesc']"
            [navigateTo]="'/cam/company-management/corporate-cards'">
        </app-cam-empty-state>
    </ng-container>
</form>

<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.warningList[0]?.title}}</h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">Are you sure you want to remove this corporate cards?</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button
                            (click)="CloseDialog(false)">{{content?.warningList[0]?.cancelCTAText}}</button>
                        <button class="button--primary-small button--primary-small-custom-width" mat-button
                            (click)="CloseDialog(true)">{{content?.warningList[0]?.confirmCTAText}}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #amexCoBrandedCardTemplate>
    <div class="custom-popup-gen-container corporate-card-popup">
        <div class="custom-popup-gen-header">
            <span>{{ 'Earn Business Miles on your Spending' }}</span>
            <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button"
                aria-label="close button" (keyup.space)="dialog.closeAll()" (keydown.enter)="dialog.closeAll()"
                (click)="dialog.closeAll()">
                close
            </mat-icon>
        </div>
        <div class="custom-popup-gen-body">
            <!-- <p>{{ 'To proceed, please update all employees’ email addresses individually to the new domain.' }}</p> -->
            <img src="assets/images/corporate-popup-card.png" alt="Corporate card">
        </div>
        <div class="custom-popup-gen-footer">
            <button class="button--secondary-small" mat-button type="button" (click)="onNoDomainPopupContinue()">
                {{ 'Learn More' }}
            </button>
            <button class="button--primary-small" mat-button type="button" (click)="onNoDomainPopupContinue()">
                {{ 'Apply Now' }}
            </button>
        </div>
    </div>
</ng-template>